<!--
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-27 11:35:45
 * @Description: 
-->
<template>
    <div class="relative !select-none pointer-events-none">
        <Board
            :is-submiting="false"
            :is-under="history.is_under"
            :progress="progress"
            :oGameResult="history"
            :historyMode="true"
        />
        <Slider
            :progress="progress"
            :is-under="history.is_under"
            :show-history="true"
        />
        <Controls
            :is-submiting="false"
            :is-under="history.is_under"
            :amount="history.amount"
            :progress="progress"
            :mutipler="history.multi"
            :history="history"
        />
    </div>
</template>


<script lang="ts" setup>
import Board from '~/pages/casino/diceGame/_components/Board.vue';
import Controls from '~/pages/casino/diceGame/_components/Controls.vue';
import Slider from '~/pages/casino/diceGame/_components/Slider.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { randomSeedValueRegxp } from '~/utils/regxp';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});

const progress = Number(props.history.prediction);

</script>
